<template>
  <div>
    Beung Firewall List
  </div>
</template>

<script>

import { EventBus } from '@/utils/event-bus'

export default {
  name: 'BeungFirewall',
  created () {
    EventBus.$emit('onLoading', false)
  }
}
</script>

<style lang="scss" scoped>

</style>
